"use client"
/* */
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'react';
import styles from '../../MenuItem.module.scss.mjs';
import '../../../../lib/propsContext/propsContext.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../../../lib/propsContext/PropsContextProvider.mjs';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import { IconCheckboxChecked } from '../../../Icon/components/icons/IconCheckboxChecked.mjs';
import { IconCheckboxEmpty } from '../../../Icon/components/icons/IconCheckboxEmpty.mjs';
import { IconRadioOff } from '../../../Icon/components/icons/IconRadioOff.mjs';
import { IconRadioOn } from '../../../Icon/components/icons/IconRadioOn.mjs';
import clsx from 'clsx';
import { Switch } from '../../../Switch/Switch.mjs';

const MenuItemContent = (props) => {
  const {
    selectionMode,
    isSelected,
    selectionVariant = "control",
    children
  } = props;
  const propsContext = {
    Icon: {
      className: styles.icon
    },
    Avatar: {
      className: styles.avatar
    }
  };
  const controlIconPropsContext = {
    Icon: {
      className: clsx(styles.controlIcon, styles.icon)
    },
    Switch: {
      className: clsx(styles.controlIcon, styles.switch)
    }
  };
  const selectionIcon = selectionMode === "none" || selectionVariant === "navigation" ? null : selectionVariant === "switch" ? /* @__PURE__ */ jsx(Switch, { isReadOnly: true, isSelected }) : selectionMode === "single" && isSelected ? /* @__PURE__ */ jsx(IconRadioOn, {}) : selectionMode === "single" && !isSelected ? /* @__PURE__ */ jsx(IconRadioOff, {}) : selectionMode === "multiple" && isSelected ? /* @__PURE__ */ jsx(IconCheckboxChecked, {}) : /* @__PURE__ */ jsx(IconCheckboxEmpty, {});
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(PropsContextProvider, { props: controlIconPropsContext, children: selectionIcon }),
    /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children })
  ] });
};

export { MenuItemContent };
//# sourceMappingURL=MenuItemContent.mjs.map
